module.exports = __webpack_public_path__ + "static/media/Editorial Policy.c9df34fe.pdf";